import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';

import type { AiModelsCatalogModel } from '@/domain/models/ai-model.js';
import { AiModelSelect } from '@/presentation/components/index.js';

interface Props {
    label: string;
    overrideLabel: string;
    inheritedFromLabel: string;
    overrideChecked: boolean;
    onToggleOverride: (checked: boolean) => void;
    value: string;
    onChangeValue: (modelId: string) => void;
    inheritedLabel: string;
    catalog: AiModelsCatalogModel | null;
    isLoading: boolean;
}

export function AiModelOverrideField({
    label,
    overrideLabel,
    inheritedFromLabel,
    overrideChecked,
    onToggleOverride,
    value,
    onChangeValue,
    inheritedLabel,
    catalog,
    isLoading
}: Props) {
    return (
        <Box data-testid="ai-model-override-field">
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0.5 }}>
                <Typography variant="body2" fontWeight={500}>
                    {label}
                </Typography>
                <FormControlLabel
                    control={<Switch size="small" checked={overrideChecked} onChange={(e) => onToggleOverride(e.target.checked)} />}
                    label={overrideLabel}
                    labelPlacement="end"
                    sx={{ '& .MuiFormControlLabel-label': { fontSize: 12, color: 'text.secondary' } }}
                />
            </Stack>
            {overrideChecked ? (
                <AiModelSelect label={label} value={value} onChange={onChangeValue} catalog={catalog} isLoading={isLoading} />
            ) : (
                <Box
                    sx={{
                        bgcolor: 'background.paper',
                        borderRadius: 1,
                        px: 1.5,
                        py: 1,
                        border: '1px solid',
                        borderColor: 'divider'
                    }}
                >
                    <Typography variant="body2" color="text.secondary">
                        {inheritedFromLabel}: {inheritedLabel}
                    </Typography>
                </Box>
            )}
        </Box>
    );
}
